import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Element, scroller } from 'react-scroll';

import EventItem from '../../components/EventItem';
import BirthdateItem from '../../components/BirthdateItem';
import TodoItem from '../../components/TodoItem';
import MultiSelect from '../../components/MultiSelect';

import useDiaryData from '../../hooks/useDiaryData';
import { eventStatusOptions } from '../../configs/events';

const dateDisplayFormat = 'DD MMM YYYY';

const generateDateArray = (selectedDate, data) => {
  const currentMoment = moment(selectedDate);
  const dates = data.map(e => e.date);

  return Array(currentMoment.daysInMonth())
    .fill('')
    .map((e, i) => {
      const date = moment(currentMoment)
        .date(i + 1)
        .format('YYYY-MM-DD');
      const dateIndex = dates.indexOf(date);
      if (dateIndex === -1) {
        return {
          date,
          events: [],
          birthdates: [],
          todoes: [],
        };
      } else {
        return { ...data[dateIndex] };
      }
    });
};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 800,
    margin: 'auto',
    paddingBottom: 20,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
  },
  date: {
    position: 'sticky',
    top: theme.mixins.toolbar.minHeight,
    borderBottom: `1px solid #e0e0e0`,
    backgroundColor: 'white',
    fontSize: 18,
    fontWeight: 600,
    paddingTop: 10,
    paddingBottom: 5,
    //marginBottom: 5,
    zIndex: 1,
    paddingLeft: 10,
  },
  innerDate: {
    fontSize: 16,
    fontWeight: 300,
  },
  listWrapper: {
    backgroundColor: '#f9f9f9',
    //borderTop: `1px solid #e0e0e0`,
    [theme.breakpoints.up('sm')]: {
      borderLeft: `1px solid #e0e0e0`,
      borderRight: `1px solid #e0e0e0`,
    },
  },
  noFound: {
    color: '#9c9c9c',
    fontWeight: 300,
    fontSize: 13,
    padding: 10,
    borderBottom: `1px solid #e0e0e0`,
  },
  filterWrapper: {
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
}));

function Events() {
  const theme = useTheme();
  const classes = useStyles();
  const [diary] = useDiaryData();
  const [status, setStatus] = useState([]);

  const data = generateDateArray(diary.selectedDate, diary.data);

  const handleStatusChange = event => {
    setStatus(event.target.value);
  };

  useEffect(() => {
    window.__scrollTo = (name, duration = 1500) => {
      scroller.scrollTo(name, {
        duration,
        delay: 100,
        offset: -1 * theme.mixins.toolbar.minHeight,
        smooth: 'easeOutQuart',
      });
    };
  }, [theme.mixins.toolbar.minHeight]);

  const filteredData = data.map(({ events, ...others }) => {
    if (status.length === 0) return { events, ...others };

    const filteredEvents = events.filter(event => {
      const allStatus = event.status.split(',');
      return allStatus.find(s => status.includes(s)) !== undefined;
    });

    return {
      ...others,
      events: filteredEvents,
      birthdates: [],
      todoes: [],
    };
  });
  // console.log(data);

  return (
    <div className={classes.root} fullWidth>
      <div className={classes.filterWrapper}>
        <MultiSelect
          label="Status filter"
          value={status}
          maxWidth="100%"
          onChange={handleStatusChange}
          options={eventStatusOptions.filter(option => option.value !== '12')}
        />
      </div>

      {filteredData.map((e, i) => (
        <Element key={e.date} name={e.date}>
          <Typography className={classes.date}>
            {`${moment(e.date).format('ddd')} `}
            <span className={classes.innerDate}>
              {moment(e.date).format(dateDisplayFormat)}
            </span>
          </Typography>
          <div className={classes.listWrapper}>
            {!Boolean(e.events.length) &&
              !Boolean(e.birthdates.length) &&
              !Boolean(e.todoes.length) && (
                <Typography className={classes.noFound}>
                  No event found
                </Typography>
              )}

            {e.birthdates.map((el, j) => (
              <BirthdateItem key={j} details={el} />
            ))}

            {e.events.map((el, j) => (
              <EventItem key={j} details={el} />
            ))}

            {e.todoes.map((el, j) => (
              <TodoItem key={j} details={el} />
            ))}
          </div>
        </Element>
      ))}
    </div>
  );
}

export default Events;
